// Date helpers — Eastern Time authoritative day (matches backend clock) and
// human-friendly relative labels used by date chips throughout the UI.

const EASTERN_TODAY = () => {
    try {
        return new Date().toLocaleDateString("en-CA", {
            timeZone: "America/New_York",
        });
    } catch {
        return new Date().toISOString().slice(0, 10);
    }
};

export const TODAY = () => EASTERN_TODAY();

// Relative date label for chips: "today" / "tomorrow" / "yesterday" /
// weekday name (±2..6 days) / "last <weekday>" / "MMM D" otherwise.
export function relativeDateLabel(dateStr, todayStr) {
    if (!dateStr) return null;
    try {
        const d = new Date(dateStr + "T12:00:00");
        const t = new Date((todayStr || TODAY()) + "T12:00:00");
        const diff = Math.round((d - t) / 86400000);
        if (diff === 0) return "today";
        if (diff === 1) return "tomorrow";
        if (diff === -1) return "yesterday";
        const wd = d.toLocaleDateString(undefined, { weekday: "short" });
        if (diff > 1 && diff <= 6) return wd;
        if (diff < -1 && diff >= -6) return `last ${wd}`;
        const opts = d.getFullYear() === t.getFullYear()
            ? { month: "short", day: "numeric" }
            : { month: "short", day: "numeric", year: "numeric" };
        return d.toLocaleDateString(undefined, opts);
    } catch {
        return dateStr;
    }
}
